import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IRoleSearch, IRoleDetail, IRoleFields } from "./rolesType"

class RoleService {
    async page(searchVo: IRoleSearch) {
        const apiUrl = "/vrm-sa/role/findPage";
        return await httpRequest.post<IPage<IRoleDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/role/findById/${id}`;
        return await httpRequest.get<IRoleDetail>(apiUrl);
    }

    async insert(insertVo: IRoleFields) {
        const apiUrl = "/vrm-sa/role/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IRoleFields) {
        const apiUrl = "/vrm-sa/role/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async change(params:IRoleFields){
        const apiUrl = "/vrm-sa/role/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}

export const roleService = new RoleService();